import { Flex, Text } from '@chakra-ui/react';
import { Grid } from '@time-line/components/common';

type HeroProps = {
  heading?: string;
};

export const Hero = ({ heading }: HeroProps) => (
  <Grid.Inner mb={{ base: 'sm', lg: 'lg' }} gridRowGap="sm">
    <Flex
      className="footer_intro"
      gridColumn="span 12"
      alignItems="center"
      justifyContent="center"
      h={{ lg: '30vh' }}
      minH={{ lg: '240px' }}
      maxH={{ lg: '360px' }}
      py={{ base: 'm', lg: 0 }}
    >
      <Text as="h2" size="h2" textAlign="center" sx={{ textWrap: 'pretty' }}>
        {heading}
      </Text>
    </Flex>
  </Grid.Inner>
);
